export const ENTITY_TYPE_OPTIONS = [
  { value: "all", label: "All Types" },
  { value: "Eventish", label: "Events" },
  { value: "Place", label: "Places" },
  { value: "Product", label: "Products" },
  { value: "Recipe", label: "Recipes" },
  { value: "Workout", label: "Workouts" },
  { value: "PersonOrgBrand", label: "People & Brands" },
  { value: "CreativeWork", label: "Creative Work" },
  { value: "Abstract", label: "Concepts" },
];
